import { apiClient } from './config';

/**
 * Fetch user's module order
 */
export const getModulesOrder = async () => {
  const response = await apiClient.get('/modules');
  return response.data;
};

/**
 * Update user's module order
 */
export const updateModulesOrder = async (modules) => {
  const response = await apiClient.put('/modules', { modules });
  return response.data;
};
